export interface Options {
  signal: AbortSignal;
}
export interface PromiseWithResolvers2<T> extends PromiseWithResolvers<T> {
  abort(reason?: any): void;
}

/**
 * @description 我想尽量还原fetch结合signal的行为，这样我们可以根据error的类型来判断错误类型
 */
export class AbortError extends Error {
  constructor(message = 'signal is aborted without reason') {
    super(message);

    this.name = 'AbortError';
  }
}

export const createPromiseWithoutResolvers = <T = unknown>() => {
  const _p = {} as PromiseWithResolvers<T>;

  _p.promise = new Promise<T>((resolve, reject) => {
    _p.resolve = resolve;
    _p.reject = reject;
  });

  return _p;
};

/**
 * @description
 * 这是`Promise.withResolvers`的hack实现，并拓展了abort功能
 * @example
 * 1. 基础使用
 * const { promise, resolve, reject, abort } = createPromise<number>();
 * 2. 如果需要在react中使用请配合诸如useRef2等具有缓存且不会反复初始化的工具
 * const { promise, resolve, reject, abort } = useRef2(() => createPromise<number>());
 * 3. 自定义signal，注意此时不会返回abort方法
 * const { signal } = new AbortController();
 * const { promise, resolve, reject } = createPromise<number>({ signal });
 * @author liuchuan
 * @todo
 * 我是否需要创建一个hook版呢
 */
export function createPromise<T = unknown>(
  options: Options,
): PromiseWithResolvers<T>;
export function createPromise<T = unknown>(): PromiseWithResolvers2<T>;
export function createPromise<T = unknown>(options?: Options) {
  const _p =
    typeof Promise.withResolvers === 'function'
      ? Promise.withResolvers<T>()
      : createPromiseWithoutResolvers<T>();
  let _signal = options?.signal;

  if (!_signal) {
    const _c = new AbortController();

    (_p as PromiseWithResolvers2<T>).abort = _c.abort.bind(_c);
    _signal = _c.signal;
  }

  if (_signal.aborted) {
    _p.reject(new AbortError(_signal.reason));
  } else {
    _signal.addEventListener(
      'abort',
      () => _p.reject(new AbortError(_signal.reason)),
      { once: true },
    );
  }

  return _p;
}
